export default "__VITE_PUBLIC_ASSET__183b8104__"